import React, {Component} from "react";

import SisModal from "store/sis/sisModal";
import SisSelect from "store/sis/component/SisSelect";

import "store/sis/css/ol.scss";

import "./weather.scss";

class WeatherLegend extends Component {
	render() {
		return (
			<div>
				<SisModal id={this.props.id} title="기상지수 정도 범례" draggable contents={<div className="weatherLegendWrap"></div>} />
			</div>
		);
	}
}

export default WeatherLegend;
